import { ranking } from '@/mocks/homeData';

const changeIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  hot: 'ri-fire-line text-accent-500',
  new: 'ri-sparkling-line text-accent-500',
};

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-fire-line"></i>
            <span>实时热度</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">热门榜单</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            根据热度、讨论和收藏综合排序的漫画人气排行榜
          </p>
        </div>

        <div className="max-w-[700px] mx-auto space-y-3">
          {ranking.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200/60 transition-colors duration-200 cursor-pointer group"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-heading text-lg font-bold flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-400 mt-1">{item.heat}</p>
              </div>

              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className={`text-lg ${changeIcons[item.change] || 'ri-subtract-line text-foreground-300'}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}